import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import Multiclamp from 'react-multi-clamp';
import cn from 'classnames';
import LazyImage from "../../LazyImage";
import { unescapeChars } from "../utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var LinkPreview = function LinkPreview(_ref) {
  var url = _ref.url,
    isDark = _ref.isDark,
    className = _ref.className;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    preview = _useState2[0],
    setPreview = _useState2[1];
  useEffect(function () {
    fetch("https://www.crehana.com/api/link-preview/?q=".concat(url)).then(function (res) {
      return res.json();
    }).then(function (response) {
      setPreview(response);
    })["catch"](function () {
      // On link preview error, the preview component won't be rendered.
    });
  }, [url]);
  if (!preview || !preview.image && !preview.title && !preview.description) {
    return null;
  }
  return /*#__PURE__*/_jsxs("a", {
    className: cn('w-full flex rounded-5 overflow-hidden', isDark ? 'text-white bg-base-lighter-24' : 'text-base-main bg-white border border-solid border-gray-main', className),
    href: url,
    target: "_blank",
    rel: "noreferrer noopener",
    children: [preview.image && /*#__PURE__*/_jsx("div", {
      className: "flex-shrink-0 w-96 h-72",
      children: /*#__PURE__*/_jsx(LazyImage, {
        className: "w-full h-full",
        imgClassName: "object-cover",
        alt: preview.title || '',
        src: preview.image,
        imgxParams: {
          w: 120,
          h: 120,
          dpr: 2,
          crop: 'faces'
        },
        dark: isDark
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col items-start px-8 py-8 sm:px-16",
      children: [preview.title && /*#__PURE__*/_jsx("div", {
        className: "mb-4 break-all font-subtitle4",
        children: /*#__PURE__*/_jsx(Multiclamp, {
          clamp: 1,
          children: unescapeChars(preview.title).replace('<', '')
        })
      }), preview.description && /*#__PURE__*/_jsx("div", {
        className: "font-legals break-word",
        children: /*#__PURE__*/_jsx(Multiclamp, {
          clamp: 2,
          children: unescapeChars(preview.description).replace('<', '')
        })
      })]
    })]
  });
};
export default LinkPreview;